export const diagnosisOptions = [
  { label: "-- Select --", value: "none", italic: true, muted: true },
  {
    label: "F32.9 Major depressive disorder, single episode, unspecified",
    value: "F32.9 Major depressive disorder, single episode, unspecified",
  },
  {
    label: "F32.0 Major depressive disorder, single episode, mild",
    value: "F32.0 Major depressive disorder, single episode, mild",
  },
  {
    label: "F32.1 Major depressive disorder, single episode, mild",
    value: "F32.1 Major depressive disorder, single episode, mild",
  },
  {
    label: "F32.1 Major depressive disorder, single episode, moderate",
    value: "F32.1 Major depressive disorder, single episode, moderate",
  },
  {
    label:
      "F32.2 Major depressive disorder, single episode, severe without psychotic features",
    value:
      "F32.2 Major depressive disorder, single episode, severe without psychotic features",
  },
  {
    label:
      "F32.3 Major depressive disorder, single episode, severe with psychotic features",
    value:
      "F32.3 Major depressive disorder, single episode, severe with psychotic features",
  },
  {
    label:
      "F32.4 Major depressive disorder, single episode, in partial remission",
    value:
      "F32.4 Major depressive disorder, single episode, in partial remission",
  },
  {
    label: "F32.5 Major depressive disorder, single episode, in full remission",
    value: "F32.5 Major depressive disorder, single episode, in full remission",
  },
  {
    label: "F32.8 Other depressive episodes",
    value: "F32.8 Other depressive episodes",
  },
  {
    label: "F33.1 Major depressive disorder, recurrent, moderate",
    value: "F33.1 Major depressive disorder, recurrent, moderate",
  },
  {
    label:
      "F33.2 Major depressive disorder, recurrent severe without psychotic features",
    value:
      "F33.2 Major depressive disorder, recurrent severe without psychotic features",
  },
  {
    label:
      "F33.3 Major depressive disorder, recurrent, severe with psychotic symptoms",
    value:
      "F33.3 Major depressive disorder, recurrent, severe with psychotic symptoms",
  },
  {
    label: "F39 Unspecified mood [affective] disorder",
    value: "F39 Unspecified mood [affective] disorder",
  },
  {
    label: "F25.9 Schizoaffective disorder, unspecified",
    value: "F25.9 Schizoaffective disorder, unspecified",
  },
  {
    label: "F25.0 Schizoaffective disorder, bipolar type",
    value: "F25.0 Schizoaffective disorder, bipolar type",
  },
  {
    label: "F25.1 Schizoaffective disorder, depressive type",
    value: "F25.1 Schizoaffective disorder, depressive type",
  },
  {
    label: "F25.8 Other schizoaffective disorders",
    value: "F25.8 Other schizoaffective disorders",
  },
  {
    label:
      "F29 Unspecified psychosis not due to a substance or known physiological condition",
    value:
      "F29 Unspecified psychosis not due to a substance or known physiological condition",
  },
  {
    label: "F41.9 Anxiety disorder, unspecified",
    value: "F41.9 Anxiety disorder, unspecified",
  },
  {
    label: "F41.1 Generalized anxiety disorder",
    value: "F41.1 Generalized anxiety disorder",
  },
  {
    label: "F41.8 Other specified anxiety disorders",
    value: "F41.8 Other specified anxiety disorders",
  },
  {
    label:
      "F41.0 Panic disorder [episodic paroxysmal anxiety] without agoraphobia",
    value:
      "F41.0 Panic disorder [episodic paroxysmal anxiety] without agoraphobia",
  },
  {
    label: "F42 Obsessive-compulsive disorder",
    value: "F42 Obsessive-compulsive disorder",
  },
  {
    label: "F32.1 Agoraphobia with panic disorder",
    value: "F32.1 Agoraphobia with panic disorder",
  },
  {
    label:
      "F90.0 Attention-deficit hyperactivity disorder, predominantly inattentive type",
    value:
      "F90.0 Attention-deficit hyperactivity disorder, predominantly inattentive type",
  },
  {
    label:
      "F90.1 Attention-deficit hyperactivity disorder, predominantly hyperactive type",
    value:
      "F90.1 Attention-deficit hyperactivity disorder, predominantly hyperactive type",
  },
  {
    label: "F90.2 Attention-deficit hyperactivity disorder, combined type",
    value: "F90.2 Attention-deficit hyperactivity disorder, combined type",
  },
  {
    label: "F90.8 Attention-deficit hyperactivity disorder, another type",
    value: "F90.8 Attention-deficit hyperactivity disorder, another type",
  },
  {
    label: "F90.9 Attention-deficit hyperactivity disorder, unspecified type",
    value: "F90.9 Attention-deficit hyperactivity disorder, unspecified type",
  },
  {
    label: "G30.0 Alzheimer’s disease with early-onset",
    value: "G30.0 Alzheimer’s disease with early-onset",
  },
  {
    label: "G30.1 Alzheimer’s disease with late-onset",
    value: "G30.1 Alzheimer’s disease with late-onset",
  },
  {
    label: "G30.8 Other Alzheimer’s disease",
    value: "G30.8 Other Alzheimer’s disease",
  },
  {
    label: "G30.9 Alzheimer’s disease, unspecified",
    value: "G30.9 Alzheimer’s disease, unspecified",
  },
  {
    label: "F31.9 Bipolar disorder, unspecified",
    value: "F31.9 Bipolar disorder, unspecified",
  },
  {
    label: "F31.0 Bipolar disorder, current episode hypomanic",
    value: "F31.0 Bipolar disorder, current episode hypomanic",
  },
  {
    label:
      "F31.10 Bipolar disorder, current episode manic without psychotic features, unspecified",
    value:
      "F31.10 Bipolar disorder, current episode manic without psychotic features, unspecified",
  },
  {
    label:
      "F31.11 Bipolar disorder, current episode manic without psychotic features, mild",
    value:
      "F31.11 Bipolar disorder, current episode manic without psychotic features, mild",
  },
  {
    label:
      "F31.12 Bipolar disorder, current episode manic without psychotic features, moderate",
    value:
      "F31.12 Bipolar disorder, current episode manic without psychotic features, moderate",
  },
  {
    label:
      "F31.13 Bipolar disorder, current episode manic without psychotic features, severe",
    value:
      "F31.13 Bipolar disorder, current episode manic without psychotic features, severe",
  },
  {
    label:
      "F31.30 Bipolar disorder, current episode depressed, mild or moderate severity, unspecified",
    value:
      "F31.30 Bipolar disorder, current episode depressed, mild or moderate severity, unspecified",
  },
  {
    label: "F31.31 Bipolar disorder, current episode depressed, mild",
    value: "F31.31 Bipolar disorder, current episode depressed, mild",
  },
  {
    label: "F11.20 Opioid dependence, uncomplicated",
    value: "F11.20 Opioid dependence, uncomplicated",
  },
  {
    label: "F11.21 Opioid type dependence in remission",
    value: "F11.21 Opioid type dependence in remission",
  },
  {
    label: "F11.220 Opioid dependence with intoxication, uncomplicated",
    value: "F11.220 Opioid dependence with intoxication, uncomplicated",
  },
  {
    label: "F11.221 Opioid dependence with intoxication delirium",
    value: "F11.221 Opioid dependence with intoxication delirium",
  },
  {
    label:
      "F11.22 Opioid dependence with intoxication with perceptual disturbance",
    value:
      "F11.22 Opioid dependence with intoxication with perceptual disturbance",
  },
  {
    label: "F43.10 Posttraumatic stress disorder, unspecified",
    value: "F43.10 Posttraumatic stress disorder, unspecified",
  },
  {
    label: "F43.11 Posttraumatic stress disorder, acute",
    value: "F43.11 Posttraumatic stress disorder, acute",
  },
  {
    label: "F43.12 Posttraumatic stress disorder, chronic",
    value: "F43.12 Posttraumatic stress disorder, chronic",
  },
  {
    label: "F43.23 Adjustment disorder with mixed anxiety and depressed mood",
    value: "F43.23 Adjustment disorder with mixed anxiety and depressed mood",
  },
  {
    label: "Z79.891 Long term (current) use of opiate analgesic",
    value: "Z79.891 Long term (current) use of opiate analgesic",
  },
  {
    label: "Z79.899 Other long terms (current) drug therapy",
    value: "Z79.899 Other long terms (current) drug therapy",
  },
  {
    label:
      "Z03.89 Encounter for observation for other suspected diseases and conditions ruled out",
    value:
      "Z03.89 Encounter for observation for other suspected diseases and conditions ruled out",
  },
];
